import _ from 'lodash';
import { getConversations, getConversationById, postConversationMessage, getConversationMessages, getUnreadCount,
  putConversationParticipant, postSupportConversation, postConversation, sendBulkMessage } from '../api';
import * as actionTypes from './actionTypes';
import { dispatchErrorAction } from './index';
import { getPagesCount } from '../helpers/general';
import { CONVERSATIONS_LIST_PAGE_SIZE } from '../constants/general';
import { conversationTypes } from '../constants/conversations';

export function getUserConversations (offset) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_CONVERSATIONS_START });
    return getConversations(offset)
      .then(({ data }) => {
        const conversations = data.data;
        const pagesQuantity = getPagesCount(data.count, CONVERSATIONS_LIST_PAGE_SIZE);
        if (conversations.length) {
          const conversationMessages = conversations.reduce(function (accumulator, conversation) {
            accumulator[conversation.conversation_id] = {
              data: conversation.messages
            };

            return accumulator;
          }, {});

          dispatch({
            type: actionTypes.SET_MESSAGES,
            entities: conversationMessages
          });

          dispatch(updateUnreadMessagesQuantity());
        }

        dispatch({
          type: actionTypes.GET_CONVERSATIONS_SUCCESS,
          records: conversations,
          pagesQuantity
        });

        return data;
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_CONVERSATIONS_ERROR,
          error: error
        });
      });
  };
}

export function getUserConversationById (id) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.GET_CONVERSATIONS_START });
    return getConversationById(id)
      .then(({ data }) => {
        const conversation = data;
        const conversationsInStore = getState().conversations.records;

        if (conversation) {
          const conversationMessages = {
            [conversation.conversation_id]: {
              data: conversation.messages
            }
          };

          dispatch({
            type: actionTypes.SET_MESSAGES,
            entities: conversationMessages
          });
        }

        const updatedConversations = [conversation, ..._.reject(conversationsInStore, ['conversation_id', id])];

        dispatch(updateUnreadMessagesQuantity());

        dispatch({
          type: actionTypes.GET_CONVERSATIONS_SUCCESS,
          records: updatedConversations
        });

        return updatedConversations;
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_CONVERSATIONS_ERROR,
          error: error
        });
      });
  };
}

export function getMessagesByConversationId (conversationId, offset) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_MESSAGES_START });
    return getConversationMessages(conversationId, offset)
      .then(({ data }) => {
        dispatch({
          type: actionTypes.GET_MESSAGES_SUCCESS,
          entities: {
            [conversationId]: data
          }
        });
        return data;
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_MESSAGES_ERROR,
          error: error
        });
      });
  };
}

export function sendConversationMessage (conversationId, formData) {
  return dispatch => {
    dispatch({ type: actionTypes.SEND_MESSAGE_START });
    return postConversationMessage(conversationId, formData)
      .then(({ data }) => {
        dispatch({
          type: actionTypes.SEND_MESSAGE_SUCCESS,
          entities: {
            [conversationId]: {
              data: [data]
            }
          }
        });
        return data;
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SEND_MESSAGE_ERROR,
          error: error
        });
        dispatchErrorAction(error, dispatch);
      });
  };
}

export function pushSingleMessage (message) {
  // TODO remove creation of default date after backend fix
  const withDefaultDate = {
    dc: new Date(),
    ...message
  };
  return dispatch => {
    return dispatch({
      type: actionTypes.PUSH_SINGLE_MESSAGE,
      entities: {
        [message.conversation_id]: {
          data: [withDefaultDate]
        }
      }
    });
  };
}

export function updateUserConversationPreferences (conversationId, participantId, formData) {
  return (dispatch, getState) => {
    return putConversationParticipant(conversationId, participantId, formData)
      .then(({ data }) => {
        const existingRecords = getState().conversations.records;
        let withUpdatedRecord = [];
        if (formData.is_deleted) {
          withUpdatedRecord = existingRecords.filter(conversation => conversation.conversation_id !== conversationId);
        } else {
          withUpdatedRecord = existingRecords.map(conversation => {
            if (conversation.conversation_id === conversationId) {
              return {
                ...conversation,
                ...data
              };
            }
            return conversation;
          });
        }
        dispatch({
          type: actionTypes.SEND_CONVERSATIONS_SUCCESS,
          records: withUpdatedRecord
        });

        return data;
      });
  };
}

export function updateUnreadMessagesQuantity () {
  return dispatch => {
    return getUnreadCount().then(({ data }) => {
      dispatch({
        type: actionTypes.GET_UNREAD_MESSAGES_QUANTITY,
        unread_count: data.unread_count
      });
      return data;
    });
  };
}

export function startSupportConversation (userId) {
  return (dispatch, getState) => {
    return postSupportConversation(userId)
      .then(({ data }) => {
        const existingRecords = getState().conversations.records;
        const conversationMessages = {
          [data.conversation_id]: {
            data: data.messages
          }
        };
        const record = _.find(existingRecords, ['conversation_id', data.conversation_id]);
        let composedRecords;

        if (record) {
          composedRecords = existingRecords.map(function (conversation) {
            if (conversation.conversation_id === data.conversation_id) {
              return data;
            }

            return conversation;
          });
        } else {
          composedRecords = [...existingRecords, data];
        }

        dispatch({
          type: actionTypes.SET_MESSAGES,
          entities: conversationMessages
        });

        dispatch({
          type: actionTypes.SEND_CONVERSATIONS_SUCCESS,
          records: composedRecords
        });

        return data;
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SEND_CONVERSATIONS_ERROR,
          error: error
        });
      });
  };
}

export function sendBulkMessageAction (formData) {
  return dispatch => {
    return sendBulkMessage(formData)
      .then(({ data }) => data)
      .catch(error => {
        dispatchErrorAction(error, dispatch);
      });
  };
}

// for job and private messages:
export function startConversation (convData) {
  return (dispatch, getState) => postConversation(convData)
    .then(({ data }) => {
      if (data) {
        if (convData.type === conversationTypes.job) {
          dispatch({
            type: actionTypes.UPDATE_JOB_CONVERSATION_ID,
            conversation_id: data.conversation_id
          });
        }

        const existingRecords = getState().conversations.records;
        const conversationMessages = {
          [data.conversation_id]: {
            data: data.messages
          }
        };
        const record = _.find(existingRecords, ['conversation_id', data.conversation_id]);
        let composedRecords;

        if (record) {
          composedRecords = existingRecords.map(conversation => {
            if (conversation.conversation_id === data.conversation_id) {
              return data;
            }

            return conversation;
          });
        } else {
          composedRecords = [...existingRecords, data];
        }

        dispatch({
          type: actionTypes.SET_MESSAGES,
          entities: conversationMessages
        });

        dispatch({
          type: actionTypes.SEND_CONVERSATIONS_SUCCESS,
          records: composedRecords
        });
      }
      return data;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/conversations.js